import { useTranslation } from "react-i18next"
import { Button } from "components"
import { Box } from "theme-ui"
import { useState } from "react"
import openIcon from "./selecticon.png"
export const EditRoute = () => {
 // language translator
 const { t } = useTranslation("translation")
 const [openCards, setOpenCards] = useState<number[]>([])
 const [rotate, setRotate] = useState<boolean>(false)
 const toggleCard = (index: any) => {
  if (openCards.includes(index)) {
   setOpenCards(openCards.filter((cardIndex) => cardIndex !== index))
  } else {
   setOpenCards([...openCards, index])
  }
  setRotate(!rotate)
 }
 const nestedArrayStructure = [
  {
   heading: "Strecken",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
   ],
  },
 ]
 return (
  <div className="w-[96%] mx-auto pt-6">
   <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mb-4">
    <h1 className="Jakarta-font font-bold text-xl">{t("editRoutes")}</h1>
    <div className="flex lg:items-center lg:flex-row flex-col">
     <div>
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button size={"doublexl"} color={"gray"}>
       Test Server
      </Button>
     </div>
    </div>
   </div>
   {nestedArrayStructure.map((item, index) => (
    <div key={index} className="lg:w-[45%] w-full">
     <Box bg="highlight" className=" w-full py-3 rounded">
      <Box
       bg="gray"
       color="text-black"
       style={{ margin: "0 auto" }}
       className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
      >
       <h1>{item.heading}</h1>
       <div
        onClick={() => toggleCard(index)}
        className="h-6 w-6 rounded bg-golden flex items-center justify-center cursor-pointer"
       >
        <img className={`${rotate ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
       </div>
      </Box>
      <div>
       {!openCards.includes(index) && (
        <div>
         {item.submenu.map((sub: any, index: number) => (
          <Box key={index} bg="highlight" color="text-black">
           <div
            className={`border-b-[1.5px] border-light-gray pb-3 w-full animate-move-card ${
             index === item?.submenu?.length - 1 ? "border-none pb-0" : ""
            }`}
           >
            {sub.info !== "" ? (
             <div className="flex w-full justify-between px-4 ">
              <h1 className="w-[50%]">{sub.heading}</h1>
              <h1 className="w-[50%]">{sub.info}</h1>
             </div>
            ) : (
             ""
            )}
           </div>
          </Box>
         ))}
        </div>
       )}
      </div>
      <div className="px-2 py-4">
       <div>
        <Button size={"doublexl"}>{t("add")}</Button>
       </div>
      </div>
     </Box>
    </div>
   ))}
  </div>
 )
}
